module.exports = __webpack_public_path__ + "img/tv-que-e-uma-obra-de-arte.6b318533.png";